import React from 'react'
import {
  string, func, bool,
} from 'prop-types'
import { Button, Tooltip, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function ModelCardActionButton({
  className = '',
  icon,
  id,
  name,
  onClick,
  tooltipContent,
  isLoading = false,
  ...rest
}) {
  return (
    <Tooltip
      content={tooltipContent}
      id={`${name}-${id}`}
      randomizeID
      onClick={() => onClick(id)}
      containerClass={className}
      offset={{ top: 10 }}
      disableMobileEvent
    >
      <Button
        icon={<span className={classnames('button-icon', icon)} />}
        variant="only-icon"
        disabled={isLoading}
        {...rest}
      />
    </Tooltip>
  )
}

ModelCardActionButton.propTypes = {
  className: string,
  icon: string.isRequired,
  id: string.isRequired,
  name: string.isRequired,
  onClick: func.isRequired,
  tooltipContent: string.isRequired,
  isLoading: bool,
}

export default ModelCardActionButton
